export const kiaTruckProducts = [
  {
    id: 'kia-001',
    name: 'KIA001',
    description: 'Rhino HEAD LAMP',
    partNumber: 'ok650-51-030/040',
    price: 85000,
    image: 'https://public.readdy.ai/ai/img_res/b14da46a6176f10f1cb9a54f4d80e2ac.jpg',
    category: 'KIA TRUCK',
    inStock: true
  },
  {
    id: 'kia-002',
    name: 'KIA002',
    description: 'WIDE Bongo HEAD LAMP',
    partNumber: 'ok75E-51-030/040',
    price: 88000,
    image: 'https://readdy.ai/api/search-image?query=wide%20truck%20headlamp%20light%20assembly%20clear%20lens%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=kia-wide-bongo-headlamp&orientation=squarish',
    category: 'KIA TRUCK',
    inStock: true
  },
  {
    id: 'kia-003',
    name: 'KIA003',
    description: 'Besta HEAD LAMP',
    partNumber: 'ok711-51-030/040',
    price: 82000,
    image: 'https://readdy.ai/api/search-image?query=besta%20truck%20headlamp%20light%20assembly%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=kia-besta-headlamp&orientation=squarish',
    category: 'KIA TRUCK',
    inStock: true
  },
  {
    id: 'kia-004',
    name: 'KIA004',
    description: 'Jumbo TITAN HEAD LAMP',
    partNumber: 'ok711-51-q30/040',
    price: 95000,
    image: 'https://readdy.ai/api/search-image?query=jumbo%20titan%20truck%20headlamp%20light%20assembly%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=kia-jumbo-titan-headlamp&orientation=squarish',
    category: 'KIA TRUCK',
    inStock: true
  },
  {
    id: 'kia-005',
    name: 'KIA005',
    description: 'NEW TRADE HEAD LAMP',
    partNumber: 'ok40A-51-030/040',
    price: 78000,
    image: 'https://readdy.ai/api/search-image?query=new%20trade%20truck%20headlamp%20light%20assembly%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=kia-new-trade-headlamp&orientation=squarish',
    category: 'KIA TRUCK',
    inStock: true
  },
  {
    id: 'kia-006',
    name: 'KIA006',
    description: 'TRADE HEAD LAMP',
    partNumber: '-',
    price: 75000,
    image: 'https://readdy.ai/api/search-image?query=trade%20truck%20headlamp%20light%20assembly%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=kia-trade-headlamp&orientation=squarish',
    category: 'KIA TRUCK',
    inStock: true
  },
  {
    id: 'kia-007',
    name: 'KIA007',
    description: 'Besta LENS GLASS',
    partNumber: '-',
    price: 35000,
    image: 'https://readdy.ai/api/search-image?query=truck%20headlamp%20lens%20glass%20clear%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=kia-besta-lens&orientation=squarish',
    category: 'KIA TRUCK',
    inStock: true
  },
  {
    id: 'kia-008',
    name: 'KIA008',
    description: 'CERES TAIL LAMP',
    partNumber: '-',
    price: 65000,
    image: 'https://readdy.ai/api/search-image?query=ceres%20truck%20tail%20lamp%20red%20orange%20lens%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=kia-ceres-taillamp&orientation=squarish',
    category: 'KIA TRUCK',
    inStock: true
  },
  {
    id: 'kia-009',
    name: 'KIA009',
    description: 'CERES TAIL LENS',
    partNumber: '-',
    price: 28000,
    image: 'https://readdy.ai/api/search-image?query=ceres%20truck%20tail%20lamp%20lens%20red%20orange%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=kia-ceres-lens&orientation=squarish',
    category: 'KIA TRUCK',
    inStock: true
  }
];
